import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {MenuService} from '../app.menu.service';
import {CbetMainComponent} from './cbet-main.component';

@Component({
    /* tslint:disable:component-selector */
    selector: '[app-cbet-menuitem]',
    /* tslint:enable:component-selector */
    template: `
        <ng-container>
            <div *ngIf="root && item?.items && item?.visible !== false" class="layout-menuitem-root-text">{{item?.label}}</div>
            <a [attr.href]="item?.url" (click)="itemClick($event)" *ngIf="(!item?.routerLink || item?.items) && item?.visible !== false"
               (mouseenter)="onMouseEnter()" (keydown.enter)="itemClick($event)" [attr.target]="item?.target" [attr.tabindex]="0"
               [ngClass]="item?.class" pRipple>
                <i *ngIf="item?.icon" [ngClass]="item?.icon | iconoPrime" class="layout-menuitem-icon"></i>
                <span>{{item?.label}}</span>
                <app-notification-count-badge *ngIf="item?.showCountNotifications === true"
                                              [notificationTypes]="item?.countNotificationTypes || []"></app-notification-count-badge>
                <i class="pi pi-fw pi-angle-down menuitem-toggle-icon" *ngIf="item?.items"></i>
            </a>
            <a (click)="itemClick($event)" (mouseenter)="onMouseEnter()" *ngIf="(item?.routerLink && !item?.items) && item?.visible !== false"
               [routerLink]="item?.routerLink" [queryParams]="item?.queryParams"
               routerLinkActive="active-menuitem-routerlink" [ngClass]="item?.class" pRipple
               [routerLinkActiveOptions]="{exact: !item?.preventExact}" [attr.target]="item?.target" [attr.tabindex]="0">
                <i *ngIf="item?.icon" [ngClass]="item?.icon | iconoPrime" class="layout-menuitem-icon"></i>
                <span>{{item?.label}}</span>
                <app-notification-count-badge *ngIf="item?.showCountNotifications === true"
                                              [notificationTypes]="item?.countNotificationTypes || []"></app-notification-count-badge>
            </a>
            <div class="layout-menu-tooltip">
                <div class="layout-menu-tooltip-arrow"></div>
                <div class="layout-menu-tooltip-text">{{item?.label}}</div>
            </div>
            <div class="submenu-arrow" *ngIf="item?.items && item?.visible !== false"></div>
            <ul *ngIf="((item?.items && root) || (item?.items && active)) && item?.visible !== false"
                [@children]="(root ? 'visible' : active ? 'visibleAnimated' : 'hiddenAnimated')">
                <ng-template ngFor let-child let-i="index" [ngForOf]="item?.items">
                    <li *ngIf="child?.visible !== false" app-cbet-menuitem [item]="child" [index]="i" [parentKey]="key"
                        [class]="child?.badgeClass"></li>
                </ng-template>
            </ul>
        </ng-container>
    `,
    // Avalon solo estiliza <i>; los íconos Font Awesome van en <span> (un estilo global pisa la fuente de <i>)
    styles: [`
        span.layout-menuitem-icon {
            display: inline-block;
            vertical-align: middle;
            margin-right: 10px;
            font-size: 16px;
            color: var(--text-color-secondary);
        }

        /* El badge viene con márgenes para el menú lateral de Teki; en Avalon va junto al texto */
        app-notification-count-badge {
            margin: 0 0 0 8px;
            vertical-align: middle;
            position: relative;
            top: -1px;
        }

        app-notification-count-badge ::ng-deep .notification-menu-badge {
            min-width: 18px;
            height: 18px;
            padding: 0 5px;
            border: 0;
            border-radius: 9px;
            box-shadow: 0 0 0 2px var(--surface-overlay, #ffffff);
            font-size: 11px;
            font-weight: 600;
            line-height: 18px;
        }

        .menuitem-toggle-icon {
            margin-left: 6px;
        }
    `],
    host: {
        // Un raíz sin hijos (p. ej. Dashboard) se pinta como enlace normal: Avalon oculta el <a> de los raíces
        '[class.layout-root-menuitem]': 'root && !!item?.items',
        '[class.active-menuitem]': 'active',
        '[class.active-menuitem-notrouter]': 'active && !item?.items'
    },
    animations: [
        trigger('children', [
            state('void', style({ height: '0px' })),
            state('hiddenAnimated', style({ height: '0px' })),
            state('visibleAnimated', style({ height: '*' })),
            state('visible', style({ height: '*', 'z-index': 100 })),
            state('hidden', style({ height: '0px', 'z-index': '*' })),
            transition('visibleAnimated => hiddenAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('hiddenAnimated => visibleAnimated', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)')),
            transition('void => visibleAnimated, visibleAnimated => void', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})
export class CbetMenuitemComponent implements OnInit, OnDestroy {

    @Input() item: any;

    @Input() index: number;

    @Input() root: boolean;

    @Input() parentKey: string;

    active = false;

    key: string;

    private subscriptions: Subscription[] = [];

    constructor(public appMain: CbetMainComponent, public router: Router, private cd: ChangeDetectorRef,
                private menuService: MenuService) {
        this.subscriptions.push(this.menuService.menuSource$.subscribe(key => {
            // deactivate current active menu
            if (this.active && this.key !== key && key.indexOf(this.key) !== 0) {
                this.active = false;
            }
        }));

        this.subscriptions.push(this.menuService.resetSource$.subscribe(() => {
            this.active = false;
        }));

        this.subscriptions.push(this.router.events.pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                if (this.appMain.isHorizontal() || this.appMain.isSlim()) {
                    this.active = false;
                } else if (this.item?.routerLink) {
                    this.updateActiveStateFromRoute();
                } else {
                    this.active = false;
                }
            }));
    }

    ngOnInit() {
        if (!(this.appMain.isHorizontal() || this.appMain.isSlim()) && this.item?.routerLink) {
            this.updateActiveStateFromRoute();
        }

        this.key = this.parentKey ? this.parentKey + '-' + this.index : String(this.index);
    }

    updateActiveStateFromRoute() {
        this.active = this.router.isActive(this.item.routerLink[0], !this.item.items);
    }

    itemClick(event: Event) {
        // avoid processing disabled items
        if (this.item?.disabled) {
            event.preventDefault();
            return;
        }

        // navigate with hover in horizontal mode
        if (this.root) {
            this.appMain.menuHoverActive = !this.appMain.menuHoverActive;
        }

        // notify other items
        this.menuService.onMenuStateChange(this.key);

        // execute command
        if (this.item?.command) {
            this.item.command({originalEvent: event, item: this.item});
        }

        // toggle active state
        if (this.item?.items) {
            this.active = !this.active;
        } else {
            // activate item
            this.active = true;

            // hide overlay menus
            if (this.appMain.isMobile() || this.appMain.isOverlay()) {
                this.appMain.hideOverlayMenu();
            }

            // reset horizontal menu
            if (this.appMain.isHorizontal() || this.appMain.isSlim()) {
                this.menuService.reset();
            }

            this.appMain.menuHoverActive = false;
        }
    }

    onMouseEnter() {
        // activate item on hover
        if (this.root && this.appMain.menuHoverActive &&
            (this.appMain.isHorizontal() || this.appMain.isSlim()) && this.appMain.isDesktop()) {
            this.menuService.onMenuStateChange(this.key);
            this.active = true;
        }
    }

    ngOnDestroy() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
}
